import { useState,useEffect } from "react";
import { FormGroup, Table, Card, CardHeader, CardFooter, CardText, CardBody, Button } from 'reactstrap';
import { 
    JournalCheck,
    Bell
} from 'react-bootstrap-icons';

const ListaRegistroAlunos = ({ listaRegistroAlunos, putAlunoLista, cameraMode, alertarEmLeitura }) => {
    const [checkedState, setCheckedState] = useState(
        new Array(listaRegistroAlunos.length).fill(false)
    );
    const [allSelected, setAllSelected] = useState(false);

    const handleOnChange = (indexAluno) => {       
        const checkedStateAtualizado = checkedState.map((statusAluno, index) =>
            index === indexAluno ? !statusAluno : statusAluno
        );
        setCheckedState(checkedStateAtualizado);
    }

    const selecionarTudos = () => {
        if (allSelected) {
            setCheckedState(new Array(listaRegistroAlunos.length).fill(false));
            setAllSelected(false);
        } else {
            setCheckedState(new Array(listaRegistroAlunos.length).fill(true));
            setAllSelected(true);
        }
    }

    const renderListaAlunosResponsavel = () => {
        let renderedList = [];
        listaRegistroAlunos.map((aluno, index) => {
            renderedList.push(renderAlunoSingle(aluno, index));
        })

        return renderedList;
    }

    const prepararListaAlunos = (checkedStateAtualizado) => {
        let listaPreparada = [];
        if (checkedStateAtualizado) {
            listaRegistroAlunos.map((aluno, index) => {
                if (checkedStateAtualizado[index]) {
                    listaPreparada.push(listaRegistroAlunos[index]);
                }
            })
        } else {
            listaRegistroAlunos.map((aluno, index) => {
                if (checkedState[index]) {
                    listaPreparada.push(listaRegistroAlunos[index]);
                }
            })
        }
        return listaPreparada;
    }

    const renderAlunoSingle = (aluno, index) => {
        return (
            <>
                <Card className="my-2" className="TabelaResgistroAlunoEntradaSaida" onClick={() => {handleOnChange(index)} }>
                    <CardHeader>
                        <input
                            className="registroCheckBox"
                            type="checkbox"
                            name={aluno['nome']}
                            value={aluno['nome']}
                            checked={checkedState[index]}
                        />
                        {aluno['nome']}
                    </CardHeader>
                    <CardBody>
                        <CardText className="cardTextRegistoAluno">
                            Turma: <div className="bubbleInfoRefistro">{aluno['nomeTurma']}</div>
                            Unidade:  <div className="bubbleInfoRefistro">{aluno['nomeUnidade']} </div>
                        </CardText>
                    </CardBody>
                </Card>
                <br />
            </>
        );
    }

    return (
        <>
            <FormGroup>
                <Button className="submitRegistrosButton" type="button" onClick={() => selecionarTudos()}>
                   Selecionar Tudos
                </Button>
                <div className="CardConfigRegistroEntradaSaida">
                       {(listaRegistroAlunos === null || listaRegistroAlunos === undefined) ? (<tr> <td> none </td></tr>) : (renderListaAlunosResponsavel())}
                </div>
                <div className="BotoesLeitura">
                {cameraMode === 'ENTRADA' ? "" :
                    (<Button className="AlunoAlertButton" type="button" onClick={() => alertarEmLeitura(prepararListaAlunos())}>
                        <Bell />Alertar
                    </Button>)}
                <Button className="submitRegistrosButton" type="button" onClick={() => putAlunoLista(prepararListaAlunos())}>
                    <JournalCheck/>{cameraMode === 'ENTRADA' ? "Registrar Entrada" : "Registrar Saida"}
                </Button>
                </div>
                
            </FormGroup>
        </>
    );
}

export default ListaRegistroAlunos;